import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Button, Tooltip } from 'antd'
import { faMagnifyingGlassMinus, faMagnifyingGlassPlus } from '@fortawesome/pro-solid-svg-icons'

import TooltipIconButton from '../../../../Components/antd/Buttons/TooltipIconButton'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

export const ZOOM_LEVELS = Object.freeze([0.7, 0.8, 0.9, 1, 1.25, 1.5])
export const DEFAULT_ZOOM = 1

const GROUP_STYLE = { display: 'flex' }

const ZoomControl = ({ zoom, onChange }) => {
  const t = useSelector(selectTranslate)

  const index = useMemo(() => ZOOM_LEVELS.indexOf(zoom), [zoom])

  return (
    <Button.Group style={GROUP_STYLE}>
      <TooltipIconButton
        icon={faMagnifyingGlassMinus}
        disabled={index <= 0}
        title={t('places_occupancy_view.zoom.out')}
        onClick={() => onChange(ZOOM_LEVELS[index - 1])}
      />
      <Tooltip title={t('places_occupancy_view.zoom.reset')}>
        <Button onClick={() => onChange(DEFAULT_ZOOM)}>{Math.round(zoom * 100)} %</Button>
      </Tooltip>
      <TooltipIconButton
        icon={faMagnifyingGlassPlus}
        disabled={index >= ZOOM_LEVELS.length - 1}
        title={t('places_occupancy_view.zoom.in')}
        onClick={() => onChange(ZOOM_LEVELS[index + 1])}
      />
    </Button.Group>
  )
}

export default ZoomControl
